module.exports = __webpack_public_path__ + "static/2-59b812410daf88458819f70f61d257f0.png";